"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiCompanyCalendar {
    static getCompanyDates(token, month, year) {
        let url = `/companycalendar/dates`;
        let isFirst = true;
        if (month) {
            url += `?month=${month}`;
            isFirst = false;
        }
        if (year) {
            url += isFirst ? `?year=${year}` : `&year=${year}`;
        }
        return Client_1.default.httpGet(url, token);
    }
    static getUpcoming(token) {
        let url = `/companycalendar/upcoming`;
        return Client_1.default.httpGet(url, token);
    }
    static getCompanyTimelineDates(token) {
        let url = `/companycalendar/timelinedates`;
        return Client_1.default.httpGet(url, token);
    }
    static getCalendarEvent(token, id) {
        let url = `/companycalendar/${id}`;
        return Client_1.default.httpGet(url, token);
    }
    static upsertCalendarEvent(token, body) {
        let url = `/companycalendar/upsert`;
        return Client_1.default.httpPost(url, token, body);
    }
    static deleteCalendarEvent(token, id) {
        let url = `/companycalendar/${id}`;
        return Client_1.default.httpDelete(url, token, {});
    }
}
exports.default = ApiCompanyCalendar;
